import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  addLeadershipAttention,
  deleteLeadershipAttention,
  fetchLeadershipAttention,
  updateLeadershipAttention,
} from "./leadership.service";

export const leadershipQueryKey = (projectId) => ["project-review", "leadership-attention", projectId];

export const useLeadershipAttentionQuery = (projectId) =>
  useQuery({
    queryKey: leadershipQueryKey(projectId),
    queryFn: () => fetchLeadershipAttention(projectId),
    enabled: Boolean(projectId),
    // Always refetch when the view opens so deleted/updated reviews are never served from cache.
    staleTime: 0,
    gcTime: 60_000,
    refetchOnMount: "always",
    retry: false,
  });

export const useAddLeadershipAttentionMutation = (projectId) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (descriptions) => addLeadershipAttention(projectId, descriptions),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: leadershipQueryKey(projectId) });
    },
  });
};

export const useUpdateLeadershipAttentionMutation = (projectId) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ attentionId, payload }) =>
      updateLeadershipAttention(projectId, attentionId, payload),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: leadershipQueryKey(projectId) });
    },
  });
};

export const useDeleteLeadershipAttentionMutation = (projectId) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (attentionId) => deleteLeadershipAttention(projectId, attentionId),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: leadershipQueryKey(projectId) });
    },
  });
};
